var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99674 15.1678C4.04341 15.1678 0.830078 11.9545 0.830078 8.00114C0.830078 4.04781 4.04341 0.834473 7.99674 0.834473C11.9501 0.834473 15.1634 4.04781 15.1634 8.00114C15.1634 11.9545 11.9501 15.1678 7.99674 15.1678ZM7.99674 1.83447C4.59674 1.83447 1.83008 4.60114 1.83008 8.00114C1.83008 11.4011 4.59674 14.1678 7.99674 14.1678C11.3967 14.1678 14.1634 11.4011 14.1634 8.00114C14.1634 4.60114 11.3967 1.83447 7.99674 1.83447Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4711 10.6221C10.3845 10.6221 10.2978 10.6021 10.2178 10.5488L8.15115 9.31548C7.63781 9.00881 7.25781 8.33548 7.25781 7.74214V5.00879C7.25781 4.73546 7.48448 4.50879 7.75781 4.50879C8.03115 4.50879 8.25781 4.73546 8.25781 5.00879V7.74214C8.25781 7.98214 8.45781 8.33548 8.66448 8.45548L10.7311 9.68881C10.9711 9.82881 11.0445 10.1355 10.9045 10.3755C10.8045 10.5355 10.6378 10.6221 10.4711 10.6221Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.ea5428048d6735ce6959a198a98cd452.svg";
export { ForwardRef as ReactComponent };